
/**
 * Regresa en formato legible una fecha tipo firebase.
 * 
 * @param {Object|string} firebaseDate Datos a codificar
 * @returns {string} Cadena en Base64
 */
export const formatFirebaseDate = (firebaseDate) => {
    if (!firebaseDate || !firebaseDate._seconds) return '';
    const date = new Date(firebaseDate._seconds * 1000);
    return date.toISOString().split('T')[0];
};